module.exports = __webpack_public_path__ + "img/19.4909f892.jpg";